const FavoriteGameListReducers = (state = [], action) => {
  switch (action.type) {
    case "storeFavoriteGameList":
      return action.payload;
    case "clearFavoriteGameList":
      return [];
    default:
      return state;
  }
};
export default FavoriteGameListReducers;
